export default {"src":"/_next/static/media/icon-job-career.3391624e.svg","height":14,"width":16,"blurWidth":0,"blurHeight":0};